import { createClient } from '@supabase/supabase-js'
import type { Database } from './database.types'
import env from '@/env'

const URL = env.NEXT_PUBLIC_SUPABASE_URL
const ANON_KEY = env.NEXT_PUBLIC_SUPABASE_ANON_KEY

export const supabase = createClient<Database>(URL, ANON_KEY)